import React, { useEffect, useState } from "react";
import { oauth2 as SMART } from "fhirclient";
import FHIRContext, { FHIRContextType } from "./index";
interface FHIRContextProviderProps {
  children: React.ReactNode;
}

const FHIRContextProvider: React.FC<FHIRContextProviderProps> = ({
  children,
}) => {
  const [client, setClient] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    SMART.ready()
      .then(
        (client) => {
          setClient(client);
        },
        (error) => {
          setError(error instanceof Error ? error.message : String(error));
        }
      )
      .finally(() => setIsLoading(false));
  }, []);

  const value: FHIRContextType = {
    client,
    isLoading,
    error,
  };

  return <FHIRContext.Provider value={value}>{children}</FHIRContext.Provider>;
};

export default FHIRContextProvider;
